import { DOCUMENT, NgFor } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-range-slider',
  standalone: true,
  imports: [FormsModule, NgFor, FormsModule],
  templateUrl: './range-slider.component.html',
  styleUrl: './range-slider.component.scss',
})
export class RangeSliderComponent implements OnInit {
  @Input() inputValue: number = 100;
  @Input() min: number = 100;
  @Input() max: number = 1000;
  isRtl: boolean = false;
  @Output() sliderEvent = new EventEmitter<number>();

  constructor(@Inject(DOCUMENT) private document: Document) {}

  ngOnInit(): void {
    this.isRtl = this.document.documentElement.dir === 'rtl';
    this.sliderEvent.emit(this.inputValue);
  }

  getPercentage(value: number): number {
    if (value > 100) {
      return ((value - this.min) / (this.max - this.min)) * 100;
    }
    this.inputValue = 100;
    return 10;
  }
  updateValue(event: any) {
    if (event.target.value > 100) {
      this.sliderEvent.emit(this.inputValue);
    }
  }
}
